import ProjectConsumptionDetailsChart from '../../components/charts/production-management-charts/ProjectConsumptionDetailsChart';
import { Col, Row } from 'react-bootstrap';
import { buildMaterialStats } from '../../helpers/materialSummary';

const ConsumptionDetails = ({
  title = 'Consumption Details',
  subtitle,
  summary = []
}) => {
  const { totalKg, stats, chartData } = buildMaterialStats(summary, {
    topN: 6,
    minSliceKg: 0 // poți pune 0.05 dacă vrei să tai “mizeriile”
  });

  return (
    <Row className="g-3 mb-3">
      <Col xs={12} md={6}>
        <h3 className="text-1100 text-nowrap">{title}</h3>
        <p className="text-700 mb-md-7">
          {subtitle || 'Materials split by planned/actual kg'}
        </p>

        <div className="d-flex align-items-center justify-content-between">
          <p className="mb-0 fw-bold">Raw materials</p>
          <p className="mb-0 fs-9">
            Total (kg) <span className="fw-bold">{totalKg}</span>
          </p>
        </div>

        <hr className="bg-200 mb-2 mt-2" />

        {!stats.length ? (
          <p className="text-700 mb-0">No material data.</p>
        ) : (
          stats.map(item => (
            <div className="d-flex align-items-center mb-1" key={item.type}>
              {/* fără culori fixe pe material (că ai multe combinații) */}
              <span className="d-inline-block bg-gray-200 bullet-item me-2" />
              <p className="mb-0 fw-semi-bold text-900 lh-sm flex-1">
                {item.type}
              </p>
              <h5 className="mb-0 text-900">{item.valueKg}</h5>
            </div>
          ))
        )}
      </Col>

      <Col xs={12} md={6}>
        <div className="position-relative mb-sm-4 mb-xl-0">
          <ProjectConsumptionDetailsChart data={chartData} />
        </div>
      </Col>
    </Row>
  );
};

export default ConsumptionDetails;
